var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 54,
    height: 40,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.4v40H.3z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e73e2d",
    fillRule: "evenodd",
    d: "M-5.8 0h65.3v24H-5.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec74a",
    fillRule: "evenodd",
    stroke: "#d8aa3f",
    strokeWidth: 0.2,
    d: "M23 22c-1.5-1.1-4.3-.7-4.8-4 2.2 1.7 1.8 0 5 1.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec74a",
    fillRule: "evenodd",
    stroke: "#d8aa3f",
    strokeWidth: 0.2,
    d: "M23.5 20.6c-1.1-1.6-4-2.1-3.4-5.3 1.5 2.2 1.7.4 4.3 3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec74a",
    fillRule: "evenodd",
    stroke: "#d8aa3f",
    strokeWidth: 0.2,
    d: "M24 19.5c-.4-1.9-2.9-3.4-1.1-6.1.5 2.6 1.4 1 2.8 4.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec74a",
    fillRule: "evenodd",
    stroke: "#d8aa3f",
    strokeWidth: 0.2,
    d: "M25 18.6c.3-2-1.5-4.1 1-6.2-.3 2.7 1 1.4 1.3 5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec74a",
    fillRule: "evenodd",
    stroke: "#d8aa3f",
    strokeWidth: 0.2,
    d: "M26 17.8c1-1.7.3-4.4 3.4-5.3-1.4 2.4.3 1.7-.8 5.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec74a",
    fillRule: "evenodd",
    stroke: "#d8aa3f",
    strokeWidth: 0.2,
    d: "M27.6 18c1.4-1.3 1.5-4.1 4.8-4-2 1.8-.2 1.8-2.4 4.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec74a",
    fillRule: "evenodd",
    stroke: "#d8aa3f",
    strokeWidth: 0.2,
    d: "M28.8 18.7c1.8-.7 2.8-3.4 5.8-2.3-2.5 1-.7 1.6-3.6 3.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec74a",
    fillRule: "evenodd",
    stroke: "#d8aa3f",
    strokeWidth: 0.2,
    d: "M30 20c1.8-.3 3.5-2.7 6.2-.7-2.7.3-1.2 1.3-4.6 2.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec74a",
    fillRule: "evenodd",
    stroke: "#d8aa3f",
    strokeWidth: 0.2,
    d: "m36.7 20.3-8.7.2.3 2.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec74a",
    fillRule: "evenodd",
    stroke: "#d8aa3f",
    strokeWidth: 0.2,
    d: "m35.4 17-8 3.2 1.3 2.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec74a",
    fillRule: "evenodd",
    stroke: "#d8aa3f",
    strokeWidth: 0.2,
    d: "m29 22 4.2-7.7-6.4 6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec74a",
    fillRule: "evenodd",
    stroke: "#d8aa3f",
    strokeWidth: 0.2,
    d: "m29 21.3 1.3-8.5-4.2 7.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec74a",
    fillRule: "evenodd",
    stroke: "#d8aa3f",
    strokeWidth: 0.2,
    d: "M28.4 20.6 27 12l-1.6 8.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec74a",
    fillRule: "evenodd",
    stroke: "#d8aa3f",
    strokeWidth: 0.2,
    d: "m27.7 19.9-4.1-7.2 1.6 8.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec74a",
    fillRule: "evenodd",
    stroke: "#d8aa3f",
    strokeWidth: 0.2,
    d: "m27 19.8-6.3-5.3 4.5 7.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec74a",
    fillRule: "evenodd",
    stroke: "#d8aa3f",
    strokeWidth: 0.2,
    d: "m18.5 17.1 6.8 5.6 1-3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec74a",
    fillRule: "evenodd",
    stroke: "#d8aa3f",
    strokeWidth: 0.2,
    d: "m25.2 20.4-8-.1 8 2.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec74a",
    fillRule: "evenodd",
    stroke: "#d8aa3f",
    strokeWidth: 0.2,
    d: "M31.7 21.8a4.8 4.8 0 1 1-9.6.4 4.8 4.8 0 0 1 9.6-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005989",
    fillRule: "evenodd",
    d: "M-5.8 23.7h65.6V40H-5.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M-5.9 35.5c1.3.5 3 2 4.9 2 3.1 0 3.2-2.2 6.4-2 3.1 0 2.6 2.2 6.9 2.2 3.5 0 4.6-2.7 7.7-2.4 2.3-.1 3.2 2.6 6.7 2.6 3.6 0 4.9-2.9 7.2-2.6 2.4 0 3.2 2.4 6.5 2.4 4.4 0 5.1-2.5 7.8-2.4 2 0 3.4 1.9 6.3 2 2.2 0 4-1.7 5.3-2.3l.1-3c-1.3.6-3.3 2.2-5.3 2.2-2.9.1-4.6-1.9-6.6-1.8-2.4 0-3.3 2.4-7.3 2.4-3.7 0-4.6-2.4-7-2.4-2.3 0-3 2.6-7 2.6-3.3 0-4.6-2.5-6.9-2.5s-5 2.4-7.7 2.3c-3.8-.2-4.6-2.3-7-2.3-1.9 0-3.9 2-6 2-2.3 0-4.8-2-5-2zm0-5.7c1.3.5 3 2 4.9 2 3.1 0 3.2-2.2 6.4-2.1 3.1 0 2.6 2.3 6.9 2.3 3.5 0 4.6-2.7 7.7-2.4 2.3 0 3.2 2.6 6.7 2.6 3.6 0 4.9-2.9 7.2-2.6 2.4 0 3.2 2.4 6.5 2.4 4.4 0 5.1-2.5 7.8-2.4 2 0 3.4 1.9 6.3 2 2.2 0 4-1.7 5.3-2.3l.1-3c-1.3.6-3.3 2.2-5.3 2.2-2.9.1-4.6-1.9-6.6-1.8-2.4 0-3.3 2.4-7.3 2.4-3.7 0-4.6-2.4-7-2.4-2.3 0-3 2.6-7 2.6-3.3 0-4.6-2.5-6.9-2.5s-5 2.4-7.7 2.3c-3.8-.2-4.6-2.3-7-2.3-1.9 0-3.9 2-6 2-2.3 0-4.8-2-5-2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M-5.9 24.1c1.3.6 3 2 4.9 2 3.1 0 3.2-2.1 6.4-2 3.1 0 2.6 2.3 6.8 2.3 3.6 0 4.7-2.7 7.8-2.4 2.2-.1 3.2 2.5 6.6 2.6 3.6 0 5-3 7.2-2.7 2.4 0 3.2 2.4 6.6 2.4 4.3 0 5-2.5 7.8-2.3 1.9 0 3.4 1.8 6.2 1.9 2.2 0 4.1-1.7 5.4-2.3v-2.9c-1.3.6-3.3 2.2-5.3 2.2-2.8 0-4.6-1.9-6.5-1.9-2.4 0-3.4 2.5-7.4 2.5-3.7 0-4.5-2.5-6.9-2.5-2.3 0-3 2.7-7 2.6-3.3 0-4.6-2.5-6.9-2.5-2.5 0-5 2.5-7.7 2.3-3.8-.1-4.6-2.3-7-2.3-1.9 0-3.9 2-6 2-2.3.1-4.8-2-5-2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc84b",
    fillRule: "evenodd",
    stroke: "#d8aa3f",
    strokeWidth: 0.2,
    d: "M17.8 6c4.7-.4 3.9-.8 5.8-1.1 2.4.3 2.7 1.8 4 2.7 0 0-.5 1.7-2.1 1.5-.3-.7.8-1-2.2-2.7-1.7-.1-4.8.3-5.5-.5Zm14.8 2.6-3.5.1v.9c2.3 0 2.8-.3 3.5-1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc84b",
    fillRule: "evenodd",
    stroke: "#d8aa3f",
    strokeLinejoin: "round",
    strokeWidth: 0.2,
    d: "M20.7 8.4c.6-.3 1-.1 1.5-.2q.3.8 1.4.8a4 4 0 0 0 3.1 1.7c2.4 0 3.1-1.7 4.7-1.8h1.7Q32.8 8 32 8q-2 0-4.3.3l-2 .5C25.3 8.6 23.9 7 23 7q-.6.3-.8.6c-.5.2-1 0-1.4.7Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc84b",
    fillRule: "evenodd",
    stroke: "#d8aa3f",
    strokeWidth: 0.2,
    d: "M23.1 7.7a.2.2 0 0 1-.2.3.3.3 0 1 1 .2-.3Zm1.6.7c3.5-4.2 6.6-3.7 10.6-4 .1.5 0 1.2-1.8 1.9-2.7.4-7.3 3.1-7.3 3.1-1 0-1.5-1-1.5-1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#d9a43e",
    strokeLinecap: "round",
    strokeWidth: 0.2,
    d: "M32 5.7h2.5m-2.9.4 2 .2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.3v40H.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKi);
export default __webpack_public_path__ + "static/media/ki.851ef78ab3102c3f32fcccc4242cedee.svg";
export { ForwardRef as ReactComponent };